import { render, staticRenderFns } from "./PhoneCallModal.vue?vue&type=template&id=388baf3d&scoped=true"
import script from "./PhoneCallModal.vue?vue&type=script&lang=js"
export * from "./PhoneCallModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneCallModal.vue?vue&type=style&index=0&id=388baf3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388baf3d",
  null
  
)

export default component.exports